<div modalHeader class="modal-header py-2">
  <h2 class="my-2"><b>{{ title }} blocked time</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

@if (form) {
  <form modalContent role="form" [formGroup]="form">
    <div class="modal-body pb-0 pt-1">
      <div class="form-group">
        <label for="blocked-time-name" class="lead col-form-label">Name *</label>
        <input
          type="text"
          class="form-control"
          id="blocked-time-name"
          formControlName="name"
          name="blockedTimeName"
          placeholder="Enter name"
          [class.is-invalid]="form.get('name').invalid && form.get('name').touched"
        >
      </div>

      <div class="form-group">
        <label for="blocked-time-date" class="lead col-form-label">Date *</label>
        <input
          type="text"
          class="form-control"
          id="blocked-time-date"
          formControlName="date"
          name="blockedTimeDate"
          ngbDatepicker
          container="body"
          [weekdays]="true"
          [minDate]="minDate"
          [firstDayOfWeek]="7"
          #datepicker="ngbDatepicker"
          autocomplete="off"
          [class.is-invalid]="form.get('date').invalid && form.get('date').touched"
          (click)="datepicker.toggle()"
        >
      </div>

      <div class="form-group">
        <label class="lead col-form-label">Time range *</label>
        <div class="d-flex align-items-center">
          <div class="timepicker">
            <tr-timepicker-input elementId="blocked-time-start" formControlName="startTime"></tr-timepicker-input>
          </div>
          <span class="mx-2">to</span>
          <div class="timepicker">
            <tr-timepicker-input elementId="blocked-time-end" formControlName="endTime"></tr-timepicker-input>
          </div>
        </div>
        @if (form.getError('startBeforeEnd')) {
          <div class="error-messages">Start time must be before end time.</div>
        }
      </div>

      @if (form.getError('blockedTimeOverlap')) {
        <div class="error-messages mb-2">This blocked time overlaps an existing one.</div>
      }

      <div class="form-group">
        <label class="form-check-label d-flex align-items-center mb-2">
          <tablesready-switcher id="all-services" formControlName="allServices"></tablesready-switcher>
          <span class="ml-2">All services</span>
        </label>

        @if (!allServices) {
          <frontend-dropdown-clear [dropdown]="servicesDropdown">
            <label for="blocked-time-services" class="lead col-form-label">Services *</label>
          </frontend-dropdown-clear>
          <frontend-dropdown
            #servicesDropdown
            elementId="blocked-time-services"
            [items]="enabledServices"
            [multiple]="true"
            [clearable]="true"
            [inlineClearButton]="false"
            clearAllText="Clear"
            bindLabel="name"
            bindValue="_id"
            formControlName="services"
          ></frontend-dropdown>
          @if (form.getError('servicesRequired')) {
            <div class="error-messages">Select at least one service.</div>
          }

          @if (filteredResources.length) {
            <frontend-dropdown-clear [dropdown]="resourcesDropdown">
              <label for="blocked-time-resources" class="lead col-form-label mt-2">Resources (optional)</label>
            </frontend-dropdown-clear>
            <frontend-dropdown
              #resourcesDropdown
              elementId="blocked-time-resources"
              [items]="filteredResources"
              [multiple]="true"
              [clearable]="true"
              [inlineClearButton]="false"
              clearAllText="Clear"
              bindLabel="name"
              bindValue="_id"
              formControlName="resources"
            ></frontend-dropdown>
            <small class="text-muted d-block">Filtered to show only resources linked to selected services.</small>
          }
        }
      </div>

      <div class="form-group">
        <label for="blocked-time-reason" class="lead col-form-label">Reason (optional)</label>
        <input
          type="text"
          class="form-control"
          id="blocked-time-reason"
          formControlName="reason"
          name="blockedTimeReason"
          placeholder="e.g. Large VIP party reserved"
        >
      </div>
    </div>
  </form>
}

<div modalFooter class="modal-footer">
  @if (isEdit) {
    <button
      type="button"
      class="btn btn-danger"
      (click)="delete()"
    >Delete
    </button>
  }


  <button
    class="btn btn-info"
    type="submit"
    [disabled]="form.pristine || !form.valid"
    (click)="confirm()"
  >Save Blocked Time</button>

  <button
    type="button"
    class="btn btn-light"
    (click)="cancel()"
    >Cancel
  </button>
</div>
